"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Product extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'product';
        this._name = initParams.name;
        this._description = initParams.description;
        this._images = (0, util_1.camelArray)(initParams.images);
        this._prices = (0, util_1.camelArray)(initParams.prices);
        this._metadata = initParams.metadata;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    get name() {
        return this._name;
    }
    set description(value) {
        console.error('Do not set objects this way');
    }
    get description() {
        return this._description;
    }
    set images(value) {
        console.error('Do not set objects this way');
    }
    get images() {
        return this._images;
    }
    set prices(value) {
        console.error('Do not set objects this way');
    }
    get prices() {
        return this._prices;
    }
    set metadata(value) {
        console.error('Do not set objects this way');
    }
    get metadata() {
        return this._metadata;
    }
}
exports.default = Product;
//# sourceMappingURL=product.js.map